<div class="flex flexWrap--wrap flexJustify--between flexAlign--center mt-0050"
     [formGroup]="formGroup"
     *ngIf="formGroup">
  <mat-form-field [hideRequiredMarker]="true"
                  class="col__">
    <mat-label>Country</mat-label>
    <mat-select placeholder="Country"
                formControlName="country"
                [disableRipple]="true"
                data-test-id="countryInput">
      <mat-option *ngFor="let country of countries"
                  [value]="country.abbreviation">{{ country.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="col__"
                  [hideRequiredMarker]="true">
    <mat-label>Address</mat-label>
    <!--Hidden item will contain the actual street address-->
    <input type="hidden"
           formControlName="streetAddress">
    <input matInput
           placeholder="Street Address"
           autocomplete="new-street-address"
           aria-label="Street Address"
           (blur)="onAddressBlurSetType()"
           [matAutocomplete]="auto"
           [formControl]="autocompleteAddressControl" />
    <mat-spinner style="margin-right: 1em"
                 [diameter]="'20'"
                 matSuffix
                 *ngIf="addressAutocompleter?.searching | async"></mat-spinner>
    <mat-autocomplete #auto="matAutocomplete"
                      [displayWith]="displayAutocompleteAddrFn"
                      (optionSelected)="onAddressSelected($event)">
      <mat-option *ngFor="let result of (addressAutocompleter.currentResults | async)"
                  [value]="result">
        <span>{{ result.streetAddress }}</span> |
          <small *ngIf="!isInternationalCountry(result.country)">{{ result.city}}, {{ result.state }}</small>
          <small *ngIf="isInternationalCountry(result.country)">{{ result.city}}, {{ result.zip }}</small>
      </mat-option>

    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="col--city"
                  [hideRequiredMarker]="true">
    <mat-label>City</mat-label>
    <input matInput
           type="text"
           data-test-id="cityInput"
           formControlName="city"
           autocomplete="new-city" />
    <app-input-error [formControlItem]="formGroup.controls.city"></app-input-error>
  </mat-form-field>

  <mat-form-field *ngIf="!isInternationalCountry(formGroup.value.country)"
                  class="col--state"
                  [hideRequiredMarker]="true">
    <mat-label>State/Prov</mat-label>
    <mat-select placeholder="State"
                formControlName="state"
                [disableRipple]="true"
                data-test-id="stateSelect">
      <mat-option *ngFor="let state of states"
                  [value]="state.abbreviation">{{
        state.abbreviation
        }}</mat-option>
    </mat-select>
    <app-input-error *ngIf="formGroup.touched"
                     [formControlItem]="formGroup.controls.state"></app-input-error>
  </mat-form-field>

  <mat-form-field
                    [ngClass]="{'col--zip': !isInternationalCountry(formGroup.value.country), 'col--zip-intl': isInternationalCountry(formGroup.value.country)}"
                  [hideRequiredMarker]="true">
    <mat-label>Zip/Postal Code</mat-label>
    <input matInput
           data-test-id="zipInput"
           [attr.type]="formGroup.value.country === 'US' ? 'tel' : 'text'"
           formControlName="zip"
           autocomplete="new-postal-code" />
    <app-input-error
       *ngIf="formGroup.touched"
       [formControlItem]="formGroup.controls.zip"></app-input-error>
  </mat-form-field>

  <div class="col__ mb-0025 d-flex--md flexAlign-center flexJustify-between"
       *ngIf="!hideConfirmedCheckbox">
    <mat-radio-group formControlName="addressType"
                     class="w-100 w-auto--md d-block mb-0050 mb-0--md">
      <mat-radio-button [value]="'physical'"
                        [disableRipple]="true">
        Physical <!-- should be selected by default -->
      </mat-radio-button>
      <mat-radio-button [value]="'mailing'"
                        [disableRipple]="true">
        Mailing
      </mat-radio-button>
    </mat-radio-group>
    <mat-checkbox formControlName="verified"
                  disableRipple
                  data-test-id="addressVerifiedCheckbox"
                  class="d-block--md">Confirmed</mat-checkbox>
  </div>

</div>
